import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  colors: {
    main: '#3949AB',
    lightMain: '#7685D8',
    darkMain: '#283593',
    secondary: '#FF9800',
    lightSecondary: '#FFB74D',
    darkSecondary: '#EF6C00',
    background: '#F8F9FD',
    lightGrey: '#F0F0F0',
    grey: '#bdbdbd',
    black: '#303030',
    white: '#ffffff',
    success: '#66BB6A',
    lightSuccess: '#E8F5E9',
    error: '#e53935',
    warning: '#FFA726',
    lightError: '#FFCDD2',
    inputPlacholder: '#C7C7CD',
  },
  fontSize: {
    heading: '3rem',
    headingSmall: '2.3rem',
    meneLinks: '1.8rem',
    button: '1.6rem',
    big: '2.2rem',
    medium: '1.7rem',
    normal: '1.6rem',
    small: '1.4rem',
  },
  cardShadow: '5px 5px 20px 1px rgba(0, 0, 0, 0.06)',
  inputShadow: '-2px 4px 11px rgba(114, 124, 142, 0.1)',
  mq: {
    tablet: '@media (min-width: 768px)',
    desktop: '@media (min-width: 1024px)',
    bigDesktop: '@media (min-width: 1280px)',
    huge: '@media(min-width: 1400px)',
  },
};
